export default "__VITE_ASSET__ChKxYpJ1__"